import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuthStore } from 'Store/Auth'
import { useSurveyStore } from 'Store/Survey'
import { shallow } from 'zustand/shallow'
import Swal from 'sweetalert2'

/** Ensures GET /survey/:id matches the route param (shared header + tab data). */
const useFetchSurveyDetail = () => {
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const userRoleId = useAuthStore(state => state.profile?.roleId ?? 0, shallow)
  const { selected, getOne } = useSurveyStore(
    state => ({
      selected: state.selected,
      getOne: state.getOne,
    }),
    shallow
  )

  const surveyId = id ? parseInt(id, 10) : null
  const survey = selected?.survey ?? {}
  const isSurveyLoaded =
    surveyId != null && !Number.isNaN(surveyId) && survey?.id === surveyId

  useEffect(() => {
    if (surveyId == null || Number.isNaN(surveyId)) return
    if (survey?.id !== surveyId) {
      getOne(surveyId).then(({ success, data }) => {
        const loaded = success ? data?.survey ?? data : null
        if (userRoleId === 21 && loaded && !loaded.shippingOnly) {
          Swal.fire({
            title: 'ไม่มีสิทธิ์เข้าถึง',
            text: 'คุณสามารถเข้าถึงเฉพาะแบบสำรวจที่เป็นจัดส่งอย่างเดียวเท่านั้น',
            icon: 'warning',
            confirmButtonText: 'ปิด',
          }).then(() => {
            navigate('/survey')
          })
        }
        if (!success && userRoleId === 21) {
          Swal.fire({
            title: 'ไม่มีสิทธิ์เข้าถึง',
            text: 'คุณสามารถเข้าถึงเฉพาะแบบสำรวจที่เป็นจัดส่งอย่างเดียวเท่านั้น',
            icon: 'warning',
            confirmButtonText: 'ปิด',
          }).then(() => {
            navigate('/survey')
          })
        }
      })
    } else if (userRoleId === 21 && survey?.id === surveyId && !survey.shippingOnly) {
      Swal.fire({
        title: 'ไม่มีสิทธิ์เข้าถึง',
        text: 'คุณสามารถเข้าถึงเฉพาะแบบสำรวจที่เป็นจัดส่งอย่างเดียวเท่านั้น',
        icon: 'warning',
        confirmButtonText: 'ปิด',
      }).then(() => {
        navigate('/survey')
      })
    }
  }, [getOne, navigate, survey?.id, survey?.shippingOnly, surveyId, userRoleId])

  return {
    survey,
    selected,
    surveyId,
    isSurveyLoaded,
    getOne,
  }
}

export default useFetchSurveyDetail
